import { defineDocExtension } from 'codemirror';
import * as d3 from 'd3';
import { TargetFormat } from './TargetFormat';

export function renderTarget(selection: d3.selection.Update<{ target: TargetFormat }>) {
    const dataBound = selection
        .selectAll('.target')
        .data(d => [d.target]);
    dataBound
        .exit()
        .remove();
    const enterSelection = dataBound
        .enter()
        .append('g')
        .classed('target', true);
    enterSelection
        .append('line')
        .classed('targetLine', true);
    dataBound
        .classed('hidden-group', d => d.value === null || d.value === undefined)
        .select('line')
        .attr('x1', d => d.line.x1)
        .attr('x2', d => d.line.x2)
        .attr('y1', d => d.line.y1)
        .attr('y2', d => d.line.y2)
        .attr('transform', d => `rotate(${d.line.rotate})`);
}

export function renderTargetArrow(selection: d3.selection.Update<{ target: TargetFormat }>) {
    const dataBound = selection
        .selectAll('.targetArrow')
        .data(d => [d.target]);
    dataBound
        .exit()
        .remove();
    const enterSelection = dataBound
        .enter()
        .append('g')
        .classed('targetArrow', true);
    enterSelection
        .append('path');
    dataBound
        .classed('hidden-group', d => d.value === null || d.value === undefined)
        .select('.targetArrow path')
        .attr('transform', d => 'translate(' + d.arrowPosition.x + ',' + d.arrowPosition.y + ') rotate(' + d.arrowPosition.rotate + ')')
        .attr('d', d3.svg.symbol().type('triangle-down'));
}
